import { customAlphabet } from 'nanoid'

let uid = () => {
  let nanoid = customAlphabet( '1234567890abcdefghijklmnopqrstuvexyz', 10 ) 

  return nanoid()
}

export {
  uid
}
